export enum Breakpoints {
    XS = 0,
    SM = 576,
    MD = 768,
    LG = 1024,
    XL = 1280,
}

export enum Prefixes {
    MinWidth = "min-width",
    MaxWidth = "max-width",
}

export const mediaQueriesGuard = 0.02;

export const DeviceBreakpoints = {
    MOBILE: {
        query: {
            // (min-width: 0px), (width >= 0px)
            from: `(${Prefixes.MinWidth}: 0px), (width >= 0px)`,

            // (max-width: 575.98px), (width < 576px)
            to: `(${Prefixes.MaxWidth}: ${Breakpoints.SM - mediaQueriesGuard}px), (width < ${Breakpoints.SM}px)`,
        },
        get from() {
            return this.query.from;
        },
        get to() {
            return this.query.to;
        },
        large: {
            query: {
                // (min-width: 0px), (width >= 0px)
                from: `(${Prefixes.MinWidth}: ${Breakpoints.XS}px), (width >= ${Breakpoints.XS}px)`,

                // (max-width: 767.98px), (width < 768px)
                to: `(${Prefixes.MaxWidth}: ${Breakpoints.MD - mediaQueriesGuard}px), (width < ${Breakpoints.MD}px)`,
            },
            get from() {
                return this.query.from;
            },
            get to() {
                return this.query.to;
            },
        },
    },
    TABLET: {
        portrait: {
            query: {
                from: `(${Prefixes.MinWidth}: ${Breakpoints.SM}px), (width >= ${Breakpoints.SM}px)`,
                to: `(hover: none) and (${Prefixes.MaxWidth}: ${Breakpoints.XL - mediaQueriesGuard}px), (hover: none) and (width < ${Breakpoints.XL}px), (${Prefixes.MaxWidth}: ${Breakpoints.MD - mediaQueriesGuard}), (width < ${Breakpoints.MD}px)`,
            },
            get from() {
                return this.query.from;
            },
            get to() {
                return this.query.to;
            },
        },
        landscape: {
            query: {
                from: `(${Prefixes.MinWidth}: ${Breakpoints.MD}px), (width >= ${Breakpoints.MD}px)`,
                to: `(hover: none) and (${Prefixes.MaxWidth}: ${Breakpoints.XL - mediaQueriesGuard}px), (hover: none) and (width < ${Breakpoints.XL}px), (${Prefixes.MaxWidth}: ${Breakpoints.LG - mediaQueriesGuard}px), (width < ${Breakpoints.LG}px)`,
            },
            get from() {
                return this.query.from;
            },
            get to() {
                return this.query.to;
            },
        },
        query: {
            // (min-width: 576px), (width >= 576px)
            from: ` (${Prefixes.MinWidth}: ${Breakpoints.SM}px),  (width >= ${Breakpoints.SM}px)`,

            // (hover: none) and (max-width: 1279.98px), (hover: none) and (width < 1280px), (max-width: 1023.98px), (width < 1024px)
            to: `(hover: none) and (${Prefixes.MaxWidth}: ${Breakpoints.XL - mediaQueriesGuard}px), (hover: none) and (width < ${
                Breakpoints.XL
            }px), (${Prefixes.MaxWidth}: ${Breakpoints.LG - mediaQueriesGuard}px), (width < ${Breakpoints.LG}px)`,
        },
        get from() {
            return this.query.from;
        },
        get to() {
            return this.query.to;
        },
    },
    MID_DESKTOP: {
        query: {
            // (hover: hover) and (min-width: 768px), (hover: hover) and (width >= 768px)
            from: `(hover: hover) and (${Prefixes.MinWidth}: ${Breakpoints.MD}px), (hover: hover) and (width >= ${Breakpoints.MD}px)`,

            // (max-width: 1023.98px), (width < 1024px)
            to: ` (${Prefixes.MaxWidth}:${Breakpoints.LG - mediaQueriesGuard}px),  (width < ${Breakpoints.LG}px)`,
        },
        get from() {
            return this.query.from;
        },
        get to() {
            return this.query.to;
        },
    },
    DESKTOP: {
        query: {
            // (hover: hover) and (min-width: 1024px), (hover: hover) and (width >= 1024px), (min-width: 1280px), (width >= 1280px)
            from: `(hover: hover) and (${Prefixes.MinWidth}: ${Breakpoints.LG}px), (hover: hover) and (width >= ${Breakpoints.LG}px), (${Prefixes.MinWidth}: ${Breakpoints.XL}px), (width >= ${Breakpoints.XL}px)`,
            to: "",
        },
        get from() {
            return this.query.from;
        },
        get to() {
            return this.query.to;
        },
    },
};
